function InfoIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 17 17" fill="#678EF1" {...props}>
      <path d="M8.629.8A7.969 7.969 0 00.663 8.766a7.969 7.969 0 007.966 7.966 7.969 7.969 0 007.966-7.966A7.969 7.969 0 008.628.8zm.796 11.949H7.832v-4.78h1.593v4.78zm0-6.373H7.832V4.783h1.593v1.593z" />
    </svg>
  )
}

export default InfoIcon
